import { render, staticRenderFns } from "./IpSettings.vue?vue&type=template&id=6590a8db&"
import script from "./IpSettings.vue?vue&type=script&lang=ts&"
export * from "./IpSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports